module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_photogenicjourney-71067a4828aa29c4367312439ba0bd2f.jpg";